module.exports = __webpack_public_path__ + "static/media/newyork_7.ddfff926.png";